import React from 'react';

const FooterLayout = () => {
    return (
        <footer>
            <p>
                <span>©{new Date().getFullYear()}</span>{" "}
                <span>-</span>{" "}
                Sitio web implementado por {" "}
                <a className='color-link'
                    href="https://beacons.ai/el_amigo_monti"
                    target="_blank"
                    rel="noreferrer"
                >
                    @el_amigo_monti
                </a>
            </p>
        </footer>
    );
};

export default FooterLayout;

